import Phaser from 'phaser';

export class RacingLoadingScene extends Phaser.Scene {
  private loadingBar?: Phaser.GameObjects.Graphics;
  private loadingText?: Phaser.GameObjects.Text;
  private progressBox?: Phaser.GameObjects.Graphics;
  private percentText?: Phaser.GameObjects.Text;
  private assetText?: Phaser.GameObjects.Text;
  private movingCars?: Phaser.GameObjects.Graphics[];

  constructor() {
    super({ key: 'RacingLoadingScene' });
  }

  preload(): void {
    // Load background image first
    
    // Set background color matching the racing theme (fallback)
    this.cameras.main.setBackgroundColor('#062B9C');
    
    // Create animated racing background
    this.createRacingBackground();
    
    // Create loading screen UI
    this.createLoadingUI();

    // Load all game assets
    this.loadAssets();

    // Listen to loading events
    this.setupLoadingEvents();
  }

  private createRacingBackground(): void {
    // Add background image
    
    
    // Create racing road effect overlay (optional, can be removed if background is sufficient)
    const roadGraphics = this.add.graphics();
    
    // Draw semi-transparent road overlay for additional racing effect
    roadGraphics.fillStyle(0x333333);
    roadGraphics.fillRect(this.cameras.main.centerX - 200, 0, 400, this.cameras.main.height);
    
    // Draw lane lines
    roadGraphics.lineStyle(4, 0xFFFFFF, 0.4);
    for (let i = 0; i < this.cameras.main.height; i += 60) {
      roadGraphics.lineBetween(this.cameras.main.centerX - 67, i, this.cameras.main.centerX - 67, i + 30);
      roadGraphics.lineBetween(this.cameras.main.centerX + 67, i, this.cameras.main.centerX + 67, i + 30);
    }

    // Create moving cars for animation

    // Animate road lines moving
    this.tweens.add({
      targets: roadGraphics,
      y: 60,
      duration: 1000,
      repeat: -1,
      ease: 'Linear'
    });
  }

  private createLoadingUI(): void {
    const centerX = this.cameras.main.centerX;
    const centerY = this.cameras.main.centerY;

    // Progress box background with shadow
    this.progressBox = this.add.graphics();
    this.progressBox.fillStyle(0x000000, 0.5);
    this.progressBox.fillRoundedRect(centerX - 205, centerY - 35, 410, 70, 15);
    this.progressBox.fillStyle(0x333333);
    this.progressBox.fillRoundedRect(centerX - 200, centerY - 30, 400, 60, 10);
    
    // Progress box border with racing theme colors
    this.progressBox.lineStyle(3, 0xFF6B6B, 0.8);
    this.progressBox.strokeRoundedRect(centerX - 200, centerY - 30, 400, 60, 10);

    // Progress bar
    this.loadingBar = this.add.graphics();

    // Progress percentage text
    this.percentText = this.add.text(centerX, centerY, '0%', {
      fontSize: '28px',
      color: '#FFFFFF',
      fontFamily: 'gilroy-medium',
      fontStyle: 'bold'
    }).setOrigin(0.5);

  }

  private loadAssets(): void {
    // Load custom font first
    // this.load.font('gilroy-medium', '../../../../fonts/SVN-Gilroy Medium.otf');

    this.load.font('gilroy-medium', '/fonts/SVN-Gilroy-Medium.otf', 'opentype');

    // Load racing game assets
    this.load.image('background_start', '/images/9cloud/didua/background_start.png');
    this.load.image('background_2', '/images/9cloud/didua/background_2.png');
    this.load.image('way', '/images/9cloud/didua/way.png');
    this.load.image('character', '/images/9cloud/character.png');
    
    // Load obstacle images
    this.load.image('giay', '/images/9cloud/didua/giay.png');
    this.load.image('loc', '/images/9cloud/didua/loc.png');
    this.load.image('stone', '/images/9cloud/didua/stone.png');
    this.load.image('hacker', '/images/9cloud/didua/hacker.png');
    
    this.load.image('gameover', '/images/9cloud/gameover.png');
    this.load.image('play_button', '/images/9cloud/play_button.png');
    this.load.image('bg_button', '/images/9cloud/bg_button.png');
    
    // Load back button SVG
    this.load.svg('back_button', 'data:image/svg+xml;base64,' + btoa(`
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.48356 2.592C8.30933 2.38933 10.1422 2.22222 12 2.22222C13.8578 2.22222 15.6907 2.38933 17.5164 2.592C18.5151 2.70797 19.4452 3.15847 20.1553 3.87021C20.8655 4.58194 21.3139 5.51304 21.4276 6.512C21.6213 8.32533 21.7778 10.1511 21.7778 12C21.7778 13.8489 21.6213 15.6747 21.4276 17.488C21.3139 18.487 20.8655 19.4181 20.1553 20.1298C19.4452 20.8415 18.5151 21.292 17.5164 21.408C15.6907 21.6107 13.8578 21.7778 12 21.7778C10.1422 21.7778 8.30933 21.6107 6.48356 21.408C5.48486 21.292 4.55478 20.8415 3.84466 20.1298C3.13453 19.4181 2.68614 18.487 2.57244 17.488C2.37867 15.6747 2.22222 13.8489 2.22222 12C2.22222 10.1511 2.37867 8.32533 2.57244 6.512C2.68614 5.51304 3.13453 4.58194 3.84466 3.87021C4.55478 3.15847 5.48486 2.70797 6.48356 2.592ZM12 0C10.0178 0 8.08533 0.177778 6.24 0.382222C4.73771 0.553726 3.33815 1.23016 2.27043 2.30079C1.20271 3.37142 0.530087 4.77281 0.362667 6.27556C0.167112 8.112 0 10.032 0 12C0 13.968 0.167112 15.888 0.362667 17.7244C0.530386 19.2266 1.20292 20.6274 2.27025 21.6976C3.33759 22.7679 4.73653 23.4442 6.23822 23.616C8.08533 23.8222 10.0178 24 12 24C13.9822 24 15.9147 23.8222 17.76 23.6178C19.2626 23.4462 20.6623 22.7695 21.7301 21.6985C22.7978 20.6275 23.4703 19.2257 23.6373 17.7227C23.8329 15.8898 24 13.9698 24 12C24 10.0302 23.8329 8.112 23.6373 6.27556C23.47 4.77308 22.7976 3.37189 21.7303 2.3013C20.6629 1.2307 19.2637 0.554102 17.7618 0.382222C15.9147 0.177778 13.9822 0 12 0ZM11.232 12.6311V10.4711C11.2322 10.2817 11.184 10.0954 11.092 9.92981C10.9999 9.76427 10.867 9.62501 10.706 9.52525C10.545 9.4255 10.3611 9.36857 10.1719 9.35988C9.98269 9.35118 9.79439 9.391 9.62489 9.47556C8.06044 10.2578 6.53511 11.7831 5.75289 13.3476C5.67613 13.5023 5.63619 13.6726 5.63619 13.8453C5.63619 14.018 5.67613 14.1884 5.75289 14.3431C6.53511 15.9076 8.06044 17.4293 9.62489 18.2116C9.79425 18.296 9.98239 18.3359 10.1715 18.3273C10.3605 18.3186 10.5443 18.2619 10.7053 18.1623C10.8662 18.0628 10.9991 17.9238 11.0913 17.7585C11.1835 17.5932 11.2319 17.407 11.232 17.2178V14.8533H12.7538C13.9807 14.8534 15.1584 14.3703 16.0318 13.5086C16.9052 12.6468 17.4041 11.4758 17.4204 10.2489L17.4667 6.78756C17.4704 6.49287 17.357 6.20876 17.1513 5.99772C16.9456 5.78667 16.6645 5.66599 16.3698 5.66222C16.0751 5.65845 15.791 5.7719 15.5799 5.9776C15.3689 6.18331 15.2482 6.46443 15.2444 6.75911L15.2 10.2187C15.1822 11.5573 14.0924 12.6311 12.7556 12.6311H11.232Z" fill="white"/>
      </svg>
    `));

    // Add some delay to show loading screen properly
    this.load.on('fileprogress', (file: any) => {
      console.log('Loading racing asset:', file.key);
    });
  }

  private setupLoadingEvents(): void {
    // Update progress bar with racing-themed gradient effect
    this.load.on('progress', (value: number) => {
      const centerX = this.cameras.main.centerX;
      const centerY = this.cameras.main.centerY;
      
      // Clear and redraw progress bar with racing gradient
      this.loadingBar?.clear();
      
      // Create racing gradient effect for progress bar
      const progressWidth = 380 * value;
      this.loadingBar?.fillGradientStyle(0xFF6B6B, 0xFF9F43, 0xFF6B6B, 0xFF9F43);
      this.loadingBar?.fillRoundedRect(centerX - 190, centerY - 20, progressWidth, 40, 8);
      
      // Add a subtle glow effect
      if (value > 0) {
        this.loadingBar?.lineStyle(2, 0xFFFFFF, 0.3);
        this.loadingBar?.strokeRoundedRect(centerX - 190, centerY - 20, progressWidth, 40, 8);
      }
      
      // Update percentage text with smooth animation
      const percent = Math.round(value * 100);
      this.percentText?.setText(`${percent}%`);
      
      // Add boost effect when reaching certain milestones
      if (percent === 25 || percent === 50 || percent === 75 || percent === 100) {
        this.tweens.add({
          targets: this.percentText,
          scaleX: 1.3,
          scaleY: 1.3,
          duration: 200,
          yoyo: true,
          ease: 'Power2'
        });
        
        // Add screen flash effect for 100%
        if (percent === 100) {
          const flash = this.add.rectangle(this.cameras.main.centerX, this.cameras.main.centerY, 
                                        this.cameras.main.width, this.cameras.main.height, 0xFFFFFF, 0.3);
          this.tweens.add({
            targets: flash,
            alpha: 0,
            duration: 300,
            onComplete: () => flash.destroy()
          });
        }
      }
    });

    // Update file loading text with fade effect
    this.load.on('fileprogress', (file: any) => {
      // Fade out current text, then fade in new text
      this.tweens.add({
        targets: this.assetText,
        alpha: 0,
        duration: 100,
        onComplete: () => {
          this.assetText?.setText(`Đang tải`);
          this.tweens.add({
            targets: this.assetText,
            alpha: 1,
            duration: 200
          });
        }
      });
    });

    // When loading is complete
    this.load.on('complete', () => {
      this.percentText?.setText('100%');
      
      // Add completion effect with racing theme
      
      // Add a longer delay to show completion
      this.time.delayedCall(1200, () => {
        // Fade out loading screen
        this.cameras.main.fadeOut(500, 6, 43, 156); // Racing blue fade
        this.cameras.main.once('camerafadeoutcomplete', () => {
          this.scene.start('KilobaRacingScene');
        });
      });
    });

    // Handle loading errors with better feedback
    this.load.on('loaderror', (file: any) => {
      console.error('Error loading racing asset:', file.key);
      
      // Add error effect with racing theme
      this.tweens.add({
        targets: this.assetText,
        x: this.cameras.main.centerX + 15,
        duration: 100,
        yoyo: true,
        repeat: 4,
        ease: 'Power2'
      });
    });
  }

  // Helper method to get display names for racing assets
  private getAssetDisplayName(key: string): string {
    const displayNames: { [key: string]: string } = {
      'background_start': 'Màn hình khởi động',
      'background_2': 'Hình nền đường đua',
      'way': 'Đường đua',
      'character': 'Xe đua',
      'giay': 'Chướng ngại vật - Giày',
      'loc': 'Chướng ngại vật - Lốc',
      'stone': 'Chướng ngại vật - Đá',
      'hacker': 'Chướng ngại vật - Hacker',
      'gameover': 'Màn hình kết thúc',
      'play_button': 'Nút chơi',
      'back_button': 'Nút quay lại',
      'gilroy-medium': 'Font chữ'
    };
    
    return displayNames[key] || key;
  }

  create(): void {
    // Scene is ready, loading will start automatically
    console.log('Racing loading scene created');
  }
}
